import { styledTheme } from 'components';
import React from 'react';

export interface Props {
  color?: string;
}

export const DetailIcon = ({ color }: Props): JSX.Element => {
  color = color || styledTheme.color.secondary;

  return (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2433 9.77604L13.0767 11.6094M0.609985 0.609375H12.3433M0.609985 5.00938H3.54332M0.609985 9.40938H3.54332M5.74332 7.20938C5.74332 7.98734 6.05237 8.73345 6.60247 9.28355C7.15258 9.83366 7.89868 10.1427 8.67665 10.1427C9.45462 10.1427 10.2007 9.83366 10.7508 9.28355C11.3009 8.73345 11.61 7.98734 11.61 7.20938C11.61 6.43141 11.3009 5.6853 10.7508 5.1352C10.2007 4.58509 9.45462 4.27604 8.67665 4.27604C7.89868 4.27604 7.15258 4.58509 6.60247 5.1352C6.05237 5.6853 5.74332 6.43141 5.74332 7.20938Z"
        stroke={color}
        strokeWidth="1.22"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
